import { el } from 'redom';

import application from 'application';

import { stringToSVG } from 'utilities';

import VariablesDisplay from './display';

import detailedInformationAvailabilityIndicatorIconString from 'assets/images/detailed-information-availability-indicator.svg?raw';

import './index.scss';

const detailedInformationAvailabilityIndicatorIcon = stringToSVG(detailedInformationAvailabilityIndicatorIconString);

class VariablesDisplayControl {

  constructor(configuration) {

    this.title = configuration.title || 'Available variables in editor';
    this.variables = configuration.variables;

    this.el = el('.campaign-step-content-variables-display.second-level-cta', {
      onclick: this.handleClick.bind(this)
    }, [detailedInformationAvailabilityIndicatorIcon.cloneNode(true)]);

  }

  displayVariableDetails() {

    application.dialogsManager.displayWithHeader(VariablesDisplay, {
      title: this.title,
      contentConfiguration: {
        variables: this.variables
      }
    });

  }

  handleClick(event) {

    event.stopPropagation();

    this.displayVariableDetails();

    return false;

  }

}

export default VariablesDisplayControl;